import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-200 min-h-screen" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "w-full pb-9" }
const _hoisted_4 = { class: "px-4 md:px-10 lg:px-24 mx-auto w-full -mt-64" }
const _hoisted_5 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComponent = _resolveComponent("NavbarComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_NavbarComponent),
      _createElementVNode("div", {
        class: "relative px-4 md:px-10 lg:px-24 mx-auto w-full bg-cover bg-center pb-64",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/background.png') + ')', '-webkit-clip-path': 'polygon(0 0, 100% 0, 100% 75%, 0 100%)', 'clip-path': 'polygon(0 0, 100% 0, 100% 75%, 0 100%)' })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header")
        ])
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "content")
          ])
        ])
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("footer", { class: "w-full py-5 bg-black flex flex-row items-center justify-center text-white font-semibold text-sm" }, [
      _createTextVNode(" © 2025 Desarrollado por "),
      _createElementVNode("a", {
        href: "https://qreventos.com",
        target: "qreventos"
      }, " QREventos")
    ], -1))
  ], 64))
}